<script setup lang="ts">
import { computed } from 'vue'
import type { DrawerState } from '@/stores/useDrawer'

const props = defineProps<{
  modelValue: DrawerState
}>()

const emit = defineEmits<{
  (emit: 'update:modelValue', value: DrawerState): void
}>()

const open = computed({
  get: () => props.modelValue.open,
  set: (value) =>
    emit('update:modelValue', {
      ...props.modelValue,
      open: value,
    }),
})
</script>

<template>
  <v-navigation-drawer
    v-model="open"
    location="right"
    temporary
    scrim
    floating
    :width="modelValue.width ?? 480"
    class="app-drawer"
  >
    <v-container>
      <!-- Header -->
      <div class="d-flex align-center justify-space-between mb-4">
        <h2>
          {{ modelValue.title }}
        </h2>

        <v-btn
          icon="PhX"
          variant="text"
          @click="open = false"
        />
      </div>

      <!-- Dynamic Content -->
      <component
        v-if="modelValue.component"
        :is="modelValue.component"
        v-bind="modelValue.props"
      />
    </v-container>
  </v-navigation-drawer>
</template>

<style scoped>
.app-drawer {
  position: fixed;
  background: #fff;
  top: 0;
  right: 0;
  height: 100vh;
  z-index: 2400;
}
</style>
